export default __webpack_public_path__ + "static/8-e9d52ad4331d12c6936062ce85de716a.jpg";